import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addItemStorage } from "../../redux/features/product.features";
const ProductStoreDetails = () => {
  let storageBoxState = useSelector((state) => {
    return state.storageBoxReducer;
  });

  let { storageBox } = storageBoxState;

  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products, ItemStorage } = productState;

  const [values, setValues] = useState((ItemStorage && ItemStorage) || {});
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [overlayStorageItemList, setOverlayStorageItemList] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState(
    (ItemStorage && ItemStorage.storageSlot) || null
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setRows(mapRowArray(Number(values.storageBoxRowSize)));
    setColumns(mapColumnArray(Number(values.storageBoxColumnSize)));
    setOverlayStorageItemList(
      products.filter((x) => x.storageBoxName === values.storageBoxName)
    );
  }, [values]);

  useEffect(() => {}, [storageBox]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
      ["storageBoxColumnSize"]: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxColumnSize)[0],
      ["storageBoxRowSize"]: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxRowSize)[0],
    });

    let itemStorage = {
      storageBoxName: value,
      storageSlot: null,
      storageBoxRowSize: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxRowSize)[0],
      storageBoxColumnSize: storageBox
        .filter((x) => x.storageBoxName === value)
        .map((y) => y.storageBoxColumnSize)[0],
    };
    setSelectedSlots(null);
    dispatch(addItemStorage(itemStorage));
  };

  const selectSlots = (val) => {
    let itemStorage = {
      storageBoxName: values.storageBoxName,
      storageSlot: val,
      storageBoxRowSize: values.storageBoxRowSize,
      storageBoxColumnSize: values.storageBoxColumnSize,
    };
    setSelectedSlots(val);
    dispatch(addItemStorage(itemStorage));
  };

  const mapRowArray = (size) => {
    let rowName = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "W",
      "X",
      "Y",
      "Z",
    ];

    let arr = [];
    for (let index = 0; index < size; index++) {
      const element = rowName[index];
      arr.push(element);
    }
    return arr;
  };
  const mapColumnArray = (size) => {
    let arr = [];
    for (let index = 1; index < size + 1; index++) {
      // const element = rowName[index];
      arr.push(index);
    }
    return arr;
  };

  const Grid = ({ overlayStorageItemList }) => {
    let boxName = "A";

    // let columns = [1, 2, 3, 4, 5];
    let count = 0;

    return (
      <div className="flex-col flex w-full">
        <div className="flex">
          <div className="flex w-full justify-evenly">
            <div className=" m-2 p-3 border border-2 text-center text-2xl">
              {values.storageBoxName}
            </div>
            {columns.map((y, i) => {
              i = i + 1;
              return (
                <div className=" text-white text-2xl font-extrabold flex justify-center items-center bg-gray-600 w-2/12 border-white m-2 p-2 text-center">
                  {i++}
                </div>
              );
            })}
          </div>
        </div>
        {rows.map((x) => {
          return (
            <div className="flex">
              <div
                style={{ height: 100 }}
                className="flex w-full justify-evenly"
              >
                <div className=" text-white text-2xl font-extrabold lowercase bg-blue-400 m-2 p-3 border border-2 flex justify-center items-center text-center text-2xl">
                  {x}
                </div>
                {columns.map((y, i) => {
                  count = count + 1;
                  return (
                    <div className="flex justify-center items-center rounded-full text-white text-xl font-extrabold w-2/12 border-white m-2 p-2 text-center">
                      <div
                        onClick={() => {
                          if (overlayStorageItemList.filter(
                            (z) =>
                              z.storageBoxName === values.storageBoxName &&
                              z.storageSlot &&
                              z.storageSlot.toString().toLowerCase() ===
                                String(values.storageBoxName + x + y)
                                  .toString()
                                  .toLowerCase()
                          ).length !== 0) {
                            return alert(
                              "Cannot select already reserved slots, please select new slots"
                            );
                          } else {
                            selectSlots(`${values.storageBoxName}${x}${y}`);
                          }
                        }}
                        style={{ height: 80, width: 80 }}
                        className={`    ${
                          overlayStorageItemList.filter(
                            (z) =>
                              z.storageBoxName === values.storageBoxName &&
                              z.storageSlot &&
                              z.storageSlot.toString().toLowerCase() ===
                                String(values.storageBoxName + x + y)
                                  .toString()
                                  .toLowerCase()
                          ).length !== 0
                            ? "bg-red-500 cursor-not-allowed"
                            : "bg-green-500 cursor-pointer"
                        }  lowercase flex justify-center items-center rounded-full text-white text-xl font-extrabold p-2 ${
                          selectedSlots === values.storageBoxName + x + y
                            ? "!bg-blue-700"
                            : ""
                        } 
                       
                        `}
                      >
                        <div className="flex flex-col w-full justify-between">
                          {
                            overlayStorageItemList
                              .filter(
                                (z) =>
                                  z.storageBoxName === values.storageBoxName &&
                                  z.storageSlot &&
                                  z.storageSlot.toString().toLowerCase() ===
                                    String(values.storageBoxName + x + y)
                                      .toString()
                                      .toLowerCase()
                              )
                              .map((y) => y.productId)[0]
                          }
                          <div>
                            <span className="uppercase">
                              {values.storageBoxName}
                            </span>
                            {x}
                            {y}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const items = storageBox.map((x) => x.storageBoxName);

  return (
    <div className="flex flex-col">
      <CustomSelectBox
        items={items}
        onChange={handleChange}
        title="Select Storage Box"
        name="storageBoxName"
        value={values.storageBoxName}
      />

      <div className="flex flex-col w-full">
        <div className="flex"></div>
        <div className="flex">
          <Grid overlayStorageItemList={overlayStorageItemList} />
        </div>
      </div>
    </div>
  );
};

export default ProductStoreDetails;
